import * as React from 'react';
import { useDrag } from 'react-dnd';
import { TournamentGridShortTeamData } from './TournamentGrid';
import { TOURNAMENT_SCHOOL_LOGO_FALLBACK } from 'Src/consts/tournament';

interface TeamCardProps {
  team: TournamentGridShortTeamData;
}

const TeamCard: React.FC<TeamCardProps> = ({ team }) => {
  const { teamName, schoolPic, schoolName, groupResults, areas } = team;
  const SCHOOL_PICTURE_HEIGHT = 40;

  const [{ isDragging }, dragRef] = useDrag({
    type: 'teamCard',
    item: { teamId: team.teamId },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });

  return (
    <div ref={dragRef} className={`eTeamCard${isDragging ? ' is-dragging' : ''}`}>
      <div className="eTeamCardSchoolPicWrapper">
        <img
          src={
            schoolPic ? `${schoolPic}?sizing=height&height=${SCHOOL_PICTURE_HEIGHT}` : TOURNAMENT_SCHOOL_LOGO_FALLBACK
          }
          alt=""
        />
      </div>
      <div className="eTeamCardTeamName">
        <strong>{teamName || 'Unnamed team'}</strong>
        <span>{schoolName || 'School not specified'}</span>
        {areas.length > 0 ? (
          <div className="eTeamCardAreas">
            {areas.map(area => (
              <span key={area}>{area}</span>
            ))}
          </div>
        ) : null}
        {groupResults ? <small>{groupResults}</small> : null}
      </div>
      <svg className="eTeamCardDrag" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M9 5h.01M15 5h.01M9 12h.01M15 12h.01M9 19h.01M15 19h.01" />
      </svg>
    </div>
  );
};

export default TeamCard;
